<template>
    <div class="p-3">
        travel orders
    </div>
</template>

<script>
export default {
    name: "TravelOrders",
    components: {},
    props: {},
    data() {
        return {}
    },
    mounted() {
    },
    methods: {},
    computed: {},
    filters: {},
    watch: {}
}
</script>

<style scoped>

</style>
